"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRadio = void 0;
const react_1 = __importDefault(require("react"));
const ramda_1 = require("ramda");
const styled_1 = require("./styled");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const helpers_1 = require("../helpers");
const useLabelTooltip_1 = require("../../useLabelTooltip");
const CustomRadio = (field) => {
    var _a, _b, _c;
    const uiOptions = (_b = (_a = field.uiSchema) === null || _a === void 0 ? void 0 : _a['ui:options']) !== null && _b !== void 0 ? _b : {};
    const labelTooltip = (0, useLabelTooltip_1.useLabelTooltip)(uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.labelTooltip);
    const label = (0, helpers_1.getLabel)(field);
    const options = (_c = field.options.enumOptions) === null || _c === void 0 ? void 0 : _c.map((option) => {
        var _a;
        return (react_1.default.createElement(styled_1.StyledRadioRow, { key: option.value },
            react_1.default.createElement(wl_ui_kit_1.Radio, Object.assign({}, (0, ramda_1.omit)(['is'], uiOptions), { label: option.label, name: field.id, onChange: (event) => {
                    field.onChange(event.target.value);
                }, value: option.value, checked: option.value === field.value, disabled: field.disabled || ((_a = field.options.enumDisabled) === null || _a === void 0 ? void 0 : _a.includes(option.value)) }))));
    });
    return (react_1.default.createElement("div", null,
        !(0, ramda_1.isEmpty)(label) && react_1.default.createElement(wl_ui_kit_1.FormLabel, { labelTooltip: labelTooltip }, label),
        options));
};
exports.CustomRadio = CustomRadio;
//# sourceMappingURL=custom-radio.js.map